import "core-js/modules/es.object.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import { gmToolNew } from "@/mixins/index";
import { getGiftLog } from "@/api/gmToolNew/gmToolNew";
export default {
  mixins: [gmToolNew],
  data: function data() {
    return {
      dialogShow: false,
      tabledata: [],
      reqLoading: false
    };
  },
  created: function created() {},
  methods: {
    init: function init(giftID) {
      this.tabledata = [];
      this.dialogShow = true;
      this.getDetailData(giftID);
    },
    getDetailData: function getDetailData(giftID) {
      var _this = this;

      this.reqLoading = true;
      getGiftLog({
        env_id: this.paramsData.env_id,
        gift_id: giftID,
        game_id: this.rawData.game_id
      }).then(function (res) {
        _this.tabledata = res.data.data;
      }).finally(function () {
        _this.reqLoading = false;
      });
    }
  }
};